export { PLUGIN_KEY, PLUGIN_PRIORITY, MergeCells } from "./mergeCells.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/mergeCells/index.mjs
// module id = 1488
// module chunks = 1